<template>
  <div>
    <vxe-grid
      ref="skuTable"
      auto-resize
      highlight-hover-row
      resizable
      show-footer
      size="mini"
      cell-class-name="align-top"
      :max-height="635"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :edit-rules="editRules"
      :footer-method="() => footerData"
      @edit-closed="editClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabled"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="remove(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabled"
            :content="$l('INDEX.btn_tips_copy') || '复制'"
            placement="top"
          >
            <i class="el-icon-document-copy tool-btn" @click="copy(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabledPrint"
            :content="$l('INDEX.btn_tips_printer') || '打印'"
            placement="top"
          >
            <i class="el-icon-printer tool-btn" @click="printView(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:displayName="{ row }">
        <div class="m-0">
          <div>{{ row.goodsName }}</div>
          <div>{{ row.goodsNameEn }}</div>
          <div>
            <span>SIZE:</span><span>{{ row.goodsSize }}</span>
          </div>
          <div>
            <span>COLOR:</span
            ><span>{{ row.goodsColor }}{{ row.goodsColorEn }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayNo="{ row }">
        <div class="m-0">
          <div>NC:{{ row.ncNo }}</div>
          <div>SKU:{{ row.amzSkuNo }}</div>
        </div>
      </template>
      <template v-slot:displayAmzNo="{ row }">
        <div class="m-0">
          <div>
            <span>{{ $l('form_label_StoreSkuNo') || '店铺SKU' }}:</span
            ><span style="color: #409EFF">{{ row.amzStoreSkuNo }}</span>
          </div>
          <div>
            <span>FNSKU:</span
            ><span style="color: #409EFF">{{ row.fnskuCode }}</span>
          </div>
          <div>
            <span>ASIN:</span>
            <span style="color: #409EFF">{{ row.asinCode }}</span>
          </div>
          <div>
            <span>UPC:</span>
            <span style="color: #409EFF">{{ row.upc }}</span>
          </div>
        </div>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; "
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width: 60px;" />
          </div>
        </el-image>
      </template>
    </vxe-grid>
    <printView ref="printViewRef"> </printView>
  </div>
</template>
<script>
import printView from '../print-view'
import { format, add, multiply, divideRound } from '@/libs/util.number.js'
export default {
  components: { printView },
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    disabledPrint: { typ: Boolean, default: false },
    hasVc: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: this.disabled ? { query: () => this.$emit('reload') } : null,
        zoom: true,
        custom: true,
      },
      tableData: [],
      calcTableData: [],
      format: (number) => format(number),
      multiply: (x, y) => multiply(x, y),
      divideRound: (x, y, l = 4) => divideRound(x, y, l),
    }
  },
  computed: {
    editRules() {
      return {
        inCtnQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        retailerPo: [
          {
            required: this.hasVc,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        ctnQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        // amzBoxNo: [
        //   {
        //     required: true,
        //     message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
        //   },
        // ],
      }
    },
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.calcTableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[3] = this.$l('table_label_total') || '合计'
      return [result]
    },
    tableColumns() {
      return [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: this.$l('INDEX.table_label_operation') || '操作',
          field: 'col-opt',
          headerAlign: 'center',
          align: 'center',
          fixed: 'left',
          width: 110,
          slots: { default: 'opt' },
          className: 'col-opt',
          visible: !this.disabled || !this.disabledPrint,
        },
        {
          title: this.$l('INDEX.table_label_image') || '图片',
          field: 'defaultImageUrl',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 70,
          slots: { default: 'defaultImageUrl' },
        },
        {
          title: this.$l('table_label_goodsName') || '产品名称',
          field: 'goodsName',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          minWidth: 220,
          slots: { default: 'displayName' },
        },
        {
          title: this.$l('table_label_amzSkuNo') || '产品编号',
          field: 'amzSkuNo',
          headerAlign: 'center',
          align: 'left',
          minWidth: 180,
          slots: { default: 'displayNo' },
        },
        {
          title: this.$l('table_label_displayAmzNo') || '产品贴标识',
          field: 'displayAmzNo',
          headerAlign: 'center',
          align: 'left',
          minWidth: 200,
          slots: { default: 'displayAmzNo' },
        },
        {
          title: this.$l('table_label_retailerPo') || '零售商PO',
          field: 'retailerPo',
          headerAlign: 'center',
          align: 'left',
          width: 180,
          editRender: {
            name: 'ElInput',
            props: {
              maxlength: 50,
              'show-word-limit': true,
              clearable: true,
              size: 'mini',
            },
          },
        },
        {
          title: this.$l('table_label_eanCode') || 'EAN条码',
          field: 'eanCode',
          minWidth: 160,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          visible: this.hasVc,
        },
        {
          title: this.$l('table_label_inCtnQty') || '装箱入数',
          field: 'inCtnQty',
          align: 'center',
          width: 150,
          editRender: {
            name: 'ElInputNumber',
            props: {
              precision: 0,
              min: 0,
              controls: false,
              clearable: true,
              size: 'mini',
            },
          },
          formatter: ({ cellValue }) => this.format(cellValue),
        },
        {
          title: this.$l('table_label_goodsQty') || '产品数',
          field: 'goodsQty',
          align: 'center',
          width: 150,
          isTotalColumn: true,
          formatter: ({ cellValue }) => this.format(cellValue),
        },
        {
          title: this.$l('table_label_ctnQty') || '箱数',
          field: 'ctnQty',
          align: 'center',
          width: 150,
          isTotalColumn: true,
          editRender: {
            name: 'ElInputNumber',
            props: {
              precision: 0,
              min: 0,
              controls: false,
              clearable: true,
              size: 'mini',
            },
          },
          formatter: ({ cellValue }) => this.format(cellValue),
        },
        {
          title: this.$l('table_label_amzBoxNo') || '箱号',
          field: 'amzBoxNo',
          headerAlign: 'center',
          align: 'left',
          width: 180,
          editRender: {
            name: 'ElInput',
            props: {
              maxlength: 50,
              'show-word-limit': true,
              clearable: true,
              size: 'mini',
            },
          },
        },
        {
          title: this.$l('table_label_detailRemark') || '备注',
          field: 'detailRemark',
          align: 'left',
          headerAlign: 'center',
          width: 300,
          editRender: {
            name: 'ElInput',
            props: {
              maxlength: 1000,
              'show-word-limit': true,
              clearable: true,
              size: 'mini',
            },
          },
        },
        {
          title: this.$l('table_label_poNo') || 'PO#订单号',
          field: 'poNo',
          headerAlign: 'center',
          align: 'left',
          width: 180,
          editRender: {
            name: 'ElInput',
            props: {
              maxlength: 50,
              'show-word-limit': true,
              clearable: true,
              size: 'mini',
            },
          },
        },
        {
          title: this.$l('table_label_cbm') || '单箱体积',
          field: 'cbm',
          align: 'center',
          width: 150,
          isTotalColumn: true,
          formatter: ({ row }) => {
            const { ctnLength, ctnWidth, ctnHeight } = row
            return this.format(
              this.divideRound(
                this.multiply(this.multiply(ctnLength, ctnWidth), ctnHeight),
                1000000,
                2
              )
            )
          },
        },
        {
          title: this.$l('table_label_subCbm') || '总体积',
          field: 'subCbm',
          align: 'center',
          width: 150,
          isTotalColumn: true,
          formatter: ({ cellValue }) => this.format(cellValue),
        },
        {
          title: this.$l('table_label_ctnGrossWeight') || '单箱毛重',
          field: 'ctnGrossWeight',
          align: 'center',
          width: 180,
          formatter: ({ cellValue }) => this.format(cellValue),
        },
        {
          title: this.$l('table_label_subGrossWeight') || '毛重(KGS)',
          field: 'subGrossWeight',
          align: 'center',
          width: 150,
          isTotalColumn: true,
          formatter: ({ cellValue }) => this.format(cellValue),
        },

        {
          title: this.$l('table_label_ftyPrice') || '采购单价',
          field: 'ftyPrice',
          align: 'center',
          width: 150,
          formatter: ({ cellValue }) => this.format(cellValue),
        },
        {
          title: this.$l('table_label_subAmount') || '成本金额',
          field: 'subAmount',
          align: 'center',
          width: 150,
          isTotalColumn: true,
          formatter: ({ cellValue }) => this.format(cellValue),
        },
      ]
    },
  },
  methods: {
    setData(data) {
      this.tableData = data
      this.calcTableData = data
    },
    async resetCalcTable() {
      this.calcTableData = await this.getTableData()
      this.$refs.skuTable.updateFooter()
    },
    async remove(row) {
      await this.$refs.skuTable.remove(row)
      this.resetCalcTable()
    },
    printView({ amzSkuCode, ncNo, inCtnQty, ctnQty }) {
      this.$refs.printViewRef.open(amzSkuCode, ncNo, inCtnQty, ctnQty)
    },
    async insertAt(records, row = -1) {
      const result = await this.$refs.skuTable.insertAt(records, row)
      await this.resetCalcTable()
      return result
    },
    async editClosed({ row }) {
      const {
        inCtnQty,
        ctnQty,
        ctnLength,
        ctnWidth,
        ctnHeight,
        ctnGrossWeight,
        ftyPrice,
      } = row

      const goodsQty = multiply(inCtnQty, ctnQty)
      const subCbm = multiply(
        divideRound(
          multiply(multiply(ctnLength, ctnWidth), ctnHeight),
          1000000,
          2
        ),
        ctnQty
      )
      const subGrossWeight = multiply(ctnGrossWeight, ctnQty)
      const subAmount = multiply(ftyPrice, goodsQty)

      row.goodsQty = goodsQty
      row.subCbm = subCbm
      row.subGrossWeight = subGrossWeight
      row.subAmount = subAmount

      this.resetCalcTable()
    },
    async getTableData() {
      const { fullData } = await this.$refs.skuTable.getTableData()
      return fullData
    },
    async validate() {
      const tableData = await this.getTableData()
      if (!tableData || !tableData.length) {
        this.$message.error(this.$l('tips_pleaseAddSku') || '请添加产品明细！')
        return false
      }
      const result = await this.$refs.skuTable.validate(true)
      return !result
    },
    copy(row) {
      const newRow = {
        ...row,
        retailerPo: '',
        ctnQty: 0,
        amzBoxNo: '',
        _X_ID: '',
        amzFtyNoticeOutDetailCode: '',
      }
      this.insertAt(newRow)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
